import { Routes, Route, Navigate } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { ForgotPassword } from './pages/ForgotPassword';
import { Dashboard } from './pages/Dashboard';
import { Accounts } from './pages/Accounts';
import { PostCreate } from './pages/PostCreate';
import { Calendar } from './pages/Calendar';
import { Posts } from './pages/Posts';
import { Analytics } from './pages/Analytics';
import { Brand } from './pages/Brand';
import { EditProfile } from './pages/EditProfile';
import { Settings } from './pages/Settings';
import { Inspiration } from './pages/Inspiration';
import { Sorteos, SorteoDetail } from './pages/Sorteos';
import { LinkInBio, LinkInBioEditor } from './pages/LinkInBio';
import { Api } from './pages/Api';
import { Help } from './pages/Help';
import { Approvals } from './pages/Approvals';
import { ApprovalReview } from './pages/ApprovalReview';
import { Team } from './pages/Team';
import { JoinTeam } from './pages/JoinTeam';
import { ChatGptPage } from './pages/ChatGpt';
import { Autopost } from './pages/Autopost';
import { LandingAds } from './pages/LandingAds';
import { AdminTickets, AdminTicketDetail } from './pages/AdminTickets';
import { ProgramarInstagram } from './pages/ProgramarInstagram';
import { ProgramarX } from './pages/ProgramarX';
import { ProgramarLinkedin } from './pages/ProgramarLinkedin';
import { ProgramarFacebook } from './pages/ProgramarFacebook';
import { ProgramarTiktok } from './pages/ProgramarTiktok';
import { ProgramarYoutube } from './pages/ProgramarYoutube';
import { ProgramarThreads } from './pages/ProgramarThreads';
import { ProgramarPinterest } from './pages/ProgramarPinterest';
import { ProgramarBluesky } from './pages/ProgramarBluesky';
import { ScrollToTop } from './components/ScrollToTop';
import { RouteAnalytics } from './components/RouteAnalytics';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Pricing } from './pages/Pricing';
import { Billing } from './pages/Billing';
import { AdminDashboard } from './pages/AdminDashboard';
import { AdminGrowth } from './pages/AdminGrowth';
import { AdminUsers } from './pages/AdminUsers';
import { AdminPaymentLogs } from './pages/AdminPaymentLogs';
import { AdminPlans } from './pages/AdminPlans';
import { AdminEmailTemplates } from './pages/AdminEmailTemplates';
import { AdminBlog } from './pages/AdminBlog';
import { AdminAutoblog } from './pages/AdminAutoblog';
import { AdminNewsletter } from './pages/AdminNewsletter';
import { AdminRoadmap } from './pages/AdminRoadmap';
import { AdminHealth } from './pages/AdminHealth';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { Features } from './pages/Features';
import { FeaturePage } from './pages/FeaturePage';
import { Tools } from './pages/Tools';
import { ToolPage } from './pages/ToolPage';
import { Integrations } from './pages/Integrations';
import { IntegrationPage } from './pages/IntegrationPage';
import { Alternatives } from './pages/Alternatives';
import { AlternativePage } from './pages/AlternativePage';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { DashboardLayout } from './components/DashboardLayout';
import { AdminLayout } from './components/AdminLayout';

export default function App() {
  return (
    <>
    <ScrollToTop />
    <RouteAnalytics />
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="posts/new" element={<PostCreate />} />
        <Route path="posts/:id/edit" element={<PostCreate />} />
        <Route path="posts" element={<Posts />} />
        <Route path="approvals" element={<Approvals />} />
        <Route path="equipos" element={<Team />} />
        <Route path="inspiration" element={<Inspiration />} />
        <Route path="sorteos" element={<Sorteos />} />
        <Route path="sorteos/:id" element={<SorteoDetail />} />
        <Route path="autopost" element={<Autopost />} />
        <Route path="calendar" element={<Calendar />} />
        <Route path="accounts" element={<Accounts />} />
        <Route path="brand" element={<Brand />} />
        <Route path="link-in-bio" element={<LinkInBio />} />
        <Route path="link-in-bio/:pageId" element={<LinkInBioEditor />} />
        <Route path="api" element={<Api />} />
        <Route path="help" element={<Help />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="billing" element={<Billing />} />
        <Route path="profile" element={<EditProfile />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      <Route
        path="/admin"
        element={
          <ProtectedRoute role="admin">
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="crecimiento" element={<AdminGrowth />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="plans" element={<AdminPlans />} />
        <Route path="payment-logs" element={<AdminPaymentLogs />} />
        <Route path="email-templates" element={<AdminEmailTemplates />} />
        <Route path="blog" element={<AdminBlog />} />
        <Route path="autoblog" element={<AdminAutoblog />} />
        <Route path="newsletter" element={<AdminNewsletter />} />
        <Route path="roadmap" element={<AdminRoadmap />} />
        <Route path="tickets" element={<AdminTickets />} />
        <Route path="tickets/:id" element={<AdminTicketDetail />} />
        <Route path="health" element={<AdminHealth />} />
      </Route>
      <Route path="/approve/:token" element={<ApprovalReview />} />
      <Route path="/join/:token" element={<JoinTeam />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/precios" element={<Pricing />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/features" element={<Features />} />
      <Route path="/chatgpt" element={<ChatGptPage />} />
      <Route path="/lp" element={<LandingAds />} />
      <Route path="/features/:slug" element={<FeaturePage />} />
      <Route path="/alternativas" element={<Alternatives />} />
      <Route path="/alternativas/:slug" element={<AlternativePage />} />
      <Route path="/herramientas-gratuitas" element={<Tools />} />
      <Route path="/herramientas-gratuitas/:slug" element={<ToolPage />} />
      <Route path="/integraciones" element={<Integrations />} />
      <Route path="/integraciones/:slug" element={<IntegrationPage />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/programar-instagram" element={<ProgramarInstagram />} />
      <Route path="/programar-x" element={<ProgramarX />} />
      <Route path="/programar-linkedin" element={<ProgramarLinkedin />} />
      <Route path="/programar-facebook" element={<ProgramarFacebook />} />
      <Route path="/programar-tiktok" element={<ProgramarTiktok />} />
      <Route path="/programar-youtube" element={<ProgramarYoutube />} />
      <Route path="/programar-threads" element={<ProgramarThreads />} />
      <Route path="/programar-pinterest" element={<ProgramarPinterest />} />
      <Route path="/programar-bluesky" element={<ProgramarBluesky />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
}
